import getGdnPackStatusLabelData from "utils/getGdnPackStatusLabelData";

const getStatus = (status) => {
  const { status_text, color } = getGdnPackStatusLabelData({ status });
  return { name: status_text, color };
};

export default getStatus;
